import React, { forwardRef, useRef, useEffect } from "react";
import makeStyles from "@mui/styles/makeStyles";
import swal from "sweetalert";
import { Grid, Button, Card, CardContent } from "@mui/material";

import { useQuery, useMutation } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "tabulator-tables/dist/css/tabulator.min.css"; // theme
import { ReactTabulator } from "react-tabulator";
import { useTranslation } from "react-i18next";
import encryptionService from "../../../services/encryptionService";

const OrderFormData = (props) => {
  const { t } = useTranslation();
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "menu-entry";
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const classes = useStyles();

  const { useState } = React;

  const [dataItemsShortOrder, setdataItemsShortOrder] = useState([]);

  const tblMenuRefHolder = useRef({ table: null });
  const tblMenuRef = tblMenuRefHolder.current;
  let previousMovedRowRef = useRef(null);

  let params = {
    menukey: menukey,
    action: "getMenuShortOrderLists",
    //role_id: selectedRoleData,
  };

  const {
    isLoading1,
    error1,
    isError1,
    data: menuData,
    refetch: MenuRefetch,
  } = useQuery([params], api.getMenuShortOrder, {
    onSuccess: (menuData) => {
      setdataItemsShortOrder(menuData);
    },
  });

  const menucolumns = [
    {
      rowHandle: true,
      formatter: "handle",
      headerSort: false,
      frozen: true,
      width: 30,
      minWidth: 30,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Menu Name"]),
      field: "menuname",
    },
  ];

  const { isLoadingLang, mutate: MenuOrderUpdate } = useMutation(
    api.updateMenuShortOrder,
    {
      onSuccess: (data) => {
        props.history.push("/menu-entry");

        if (data.data.status == 200) {
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        }
      },
    },
  );

  const SaveSelectedOrder = () => {
    //console.log(tblMenuRef.table.getData());
    let MenuData = tblMenuRef.table.getData();
    MenuOrderUpdate({ MenuData });
  };

  const options = {
    headerSort: false,
    movableRows: true,
  };

  const handleRowMoved = (row) => {
    // Reset the background color of the previously moved row
    if (previousMovedRowRef.current) {
      previousMovedRowRef.current.getElement().style.backgroundColor = "";
    }

    // Set the background color of the current moved row
    row.getElement().style.backgroundColor = "lightblue";

    // Store a reference to the current moved row
    previousMovedRowRef.current = row;

    console.log("Row: " + row.getData().id + " has been moved");
  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid container>
            <Grid item xs={12} sm={12}>
              <div className="sw_page_heading">
                <div className="sw_heading_title">
                  {DispensingLanguage[lan][menukey]["Menu Sort Order"]}
                </div>

                <div className="float-end sw_btn_control">
                  {/* Action buttons */}
                  {
                    <Grid item xs={12} className="mt-4 text-center">
                      <Button
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={SaveSelectedOrder}
                      >
                        {DispensingLanguage[lan][menukey]["Save"]}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/menu-entry")}
                      >
                        {DispensingLanguage[lan][menukey]["Back to List"]}
                      </Button>
                    </Grid>
                  }
                  {/* End Action buttons */}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <Grid container>
          {/* new row */}
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardContent>
                <div>
                  <div className="uniqueName">
                    <ReactTabulator
                      onRef={(r) => {
                        tblMenuRef.table = r.current;
                      }}
                      options={options}
                      columns={menucolumns}
                      data={dataItemsShortOrder}
                      layout={"fitColumns"}
                      height={"500px"}
                      rowMoved={handleRowMoved}
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default OrderFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
